import {
	MosaicNode,
	MosaicUncontrolledProps,
	MosaicWithoutDragDropContext,
} from "react-mosaic-component";
import { Box, Theme } from "@mui/material";
import { useStoredState } from "src/utils/storedState.ts";
import "react-mosaic-component/react-mosaic-component.css";
import { AavoMosaicWindow } from "src/components/common/mosaic/AavoMosaicWindow.tsx";
import { AavoMosaicNode, AavoMosaicTabWithKey } from "./types";
import { mapAavoMosaicNodes } from "src/components/common/mosaic/nodeMapping.ts";
import { SxProps } from "@mui/system";
import { mergeSx } from "src/utils/styles.ts";

export type AavoMosaicProps = Omit<
	MosaicUncontrolledProps<string>,
	"renderTile" | "initialValue"
> & {
	viewId: string;
	layout: AavoMosaicNode;
	sx?: SxProps<Theme>;
};

export const AavoMosaic = ({ viewId, layout: layoutProp, sx, ...other }: AavoMosaicProps) => {
	const { rootNode: initialLayoutRootNode, allTabs } = mapAavoMosaicNodes(layoutProp);
	const [layout, saveLayout] = useStoredState<MosaicNode<string> | null>(
		initialLayoutRootNode,
		`mosaic-layout--${viewId}`,
	);

	const tabsByKeys: Record<string, AavoMosaicTabWithKey> = Object.fromEntries(
		allTabs.map((tab) => [tab.key, tab]),
	);

	return (
		<Box className={"aavo-mosaic"} sx={mergeSx(mosaicSx, sx)}>
			<MosaicWithoutDragDropContext<string>
				className={""}
				initialValue={layout}
				onChange={saveLayout}
				renderTile={(id, path) => (
					<AavoMosaicWindow
						tabKey={id}
						path={path}
						tabsByKeys={tabsByKeys}
						resetLayout={() => saveLayout(initialLayoutRootNode)}
					/>
				)}
				{...other}
			/>
		</Box>
	);
};

const mosaicSx: SxProps<Theme> = {
	flex: 1,
	display: "flex",
	"& .mosaic-root": {
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		margin: "-3px",
	},
	"& .mosaic-tile": {
		margin: "3px",
	},
	"& .mosaic-window-toolbar": {
		height: "1.75rem !important",
	},
	"& .mosaic-split:hover": {
		backgroundColor: "primary.light",
		opacity: 0.2,
	},
};
